const { USE_OLD_STORAGE_SETTINGS } = require("../../constants/cookies");
const { getAbTestVariantNew } = require("../new-ab-tests/new-ab-tests-service");
const { BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, NEW_CRM_PRICING_TEST, CRM_PRICING_NO_BASIC_TEST, CRM_PRICING_NO_SEATS_TEST, HOMEPAGE_GOOGLE_ONE_TAP_TEST, CREDITS_PER_SEAT_HOMEPAGE_AB_TEST } = require("../../constants/new-ab-tests");
const { CRM_PRODUCT_ID } = require("constants/products");
const shouldShowBiggerStorageInPricingFeatures = (abTests = [], cookies = {}, sendBigBrainEvent = false)=>{
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
const shouldShowNewCrmPricingTest = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, NEW_CRM_PRICING_TEST.test_name, sendBigBrainEvent) === NEW_CRM_PRICING_TEST.variant_a;
};
const shouldShowCrmPricingNoBasicTest = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, CRM_PRICING_NO_BASIC_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_NO_BASIC_TEST.variant_a;
};
const shouldShowEnterpriseToUltimateRename = (product)=>{
    return product === CRM_PRODUCT_ID;
};
const shouldHideCrmSeatsSelection = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, CRM_PRICING_NO_SEATS_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_NO_SEATS_TEST.new_variation_name;
};
const shouldShowHomepageGoogleOneTap = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, HOMEPAGE_GOOGLE_ONE_TAP_TEST.test_name, sendBigBrainEvent) === HOMEPAGE_GOOGLE_ONE_TAP_TEST.new_variation_name;
};
const shouldShowCreditsPerSeatHomepageTest = (abTests = [], sendBigBrainEvent = false)=>{
    const variant = getAbTestVariantNew(abTests, CREDITS_PER_SEAT_HOMEPAGE_AB_TEST.test_name, sendBigBrainEvent);
    if (!variant) return null;
    return variant === CREDITS_PER_SEAT_HOMEPAGE_AB_TEST.new_variation_name;
};
module.exports = {
    shouldShowBiggerStorageInPricingFeatures,
    shouldShowNewCrmPricingTest,
    shouldShowCrmPricingNoBasicTest,
    shouldShowEnterpriseToUltimateRename,
    shouldHideCrmSeatsSelection,
    shouldShowHomepageGoogleOneTap,
    shouldShowCreditsPerSeatHomepageTest
};
